import { render } from "./Menu.vue?vue&type=template&id=7907c4aa&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./menu.scss?vue&type=style&index=0&id=7907c4aa&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7907c4aa"]])

export default __exports__